import React from 'react';
import { ModuleCard } from './components/ModuleCard';
import { Icons } from '../../Components/Icons/Icons';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../api/users';
import './Modules.scss';

interface Module {
  id: string;
  title: string;
  description: string;
  icon: JSX.Element;
  link: string;
}

const modules: Module[] = [
  {
    id: 'marketing-hub',
    title: 'Marketing Hub',
    description:
      'Access your agency\'s branded marketing collateral, submit job requests directly to the marketing team, and explore the calendar of events for inspiration on engaging clients and caregivers.',
    icon: Icons.ModuleMarketingHub,
    link: '/resources',
  },
  {
    id: 'leaderboard',
    title: 'Leaderboard',
    description:
      'Track progress, recognize top performers, and inspire healthy competition.',
    icon: Icons.ModuleLeaderboard,
    link: '/leaderboard',
  },
  {
    id: 'users',
    title: 'Users',
    description:
      'Manage your team with ease - add new users, assign roles, and control access. Keep your workspace secure and organized for better collaboration.',
    icon: Icons.ModuleUsers,
    link: '/users',
  },
];

export const Modules: React.FC = () => {
  const { userData } = useAuth();

  const filteredModules = modules.filter((module) => {
    switch (module.id) {
      case 'marketing-hub':
        return userData?.hasMarketingHubAccess;
      case 'leaderboard':
        return userData?.hasLeaderboardAccess;
      case 'users':
        return userData?.role === UserRole.ADMIN || userData?.role === UserRole.DIRECTOR;
      default:
        return true;
    }
  });

  return (
    <div className="modules-page">
      <h1>Modules</h1>
      <div className="modules__list">
        {filteredModules.map((module) => (
          <ModuleCard
            key={module.id}
            title={module.title}
            description={module.description}
            icon={module.icon}
            link={module.link}
          />
        ))}
      </div>
    </div>
  );
};
